import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const PostColumn = ({ posts, title, className, ...props }) => {
return (
<div className={`divide-y divide-gray-500 ${className}`} {...props}>
<h3 className="font-heading mb-4">{title}</h3>
<div className="pt-4 space-y-4">
{posts.map((post) => (
<Post post={post} key={post.id} />
))}
</div>
</div>
)
}

export default PostColumn

const Post = ({ post }) => (
<Link to={post.uri} className="group flex flex-row space-x-4 items-start">
<div className="flex-shrink-0 self-stretch h-[70px] w-[70px]">
<GatsbyImage
image={
post.featuredImage.node.localFile?.childImageSharp.gatsbyImageData
}
alt={post.title.slice(0, 20)}
className="w-full h-full object-cover text-xs"
/>
</div>
<div>
<p className="text-xs mb-1">{post.date}</p>
<h4 className="text-base group-hover:underline">{post.title}</h4>
</div>
</Link>
)